import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { AgentLockoutReason, AgentLockoutService } from '../../services/agent-lockout.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  constructor(
    private api: ApiService,
    private _router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private agentLockoutService: AgentLockoutService
  ) {}

  public message = 'User does not have license.Please contact your DaVinci administrator for license.';

  ngOnInit() {
    if (this.location.path().includes('error/profile')) {
      this.message = 'The selected profile was not found. Please contact your DaVinci administrator for proper profile assignment.';
      return;
    }

    const reasonFromQuery = this.activatedRoute.snapshot.queryParamMap.get('reason');
    const reasonFromStorage = this.agentLockoutService.getStoredReason();
    const resolvedReason = this.resolveReason(reasonFromQuery) || reasonFromStorage;

    if (resolvedReason) {
      this.message = this.resolveMessage(resolvedReason);
      this.agentLockoutService.clearStoredReason();
    }
  }

  async logout() {
    this.agentLockoutService.clearStoredReason();
    await this.api.logout().catch(() => {});
    this._router.navigate(['home']);
  }

  private resolveReason(rawReason?: string | null): AgentLockoutReason | null {
    if (!rawReason) {
      return null;
    }

    const normalizedReason = rawReason.toUpperCase();
    if ((Object.values(AgentLockoutReason) as string[]).includes(normalizedReason)) {
      return normalizedReason as AgentLockoutReason;
    }

    return null;
  }

  private resolveMessage(reason: AgentLockoutReason): string {
    switch (reason) {
      case AgentLockoutReason.NoCreditsRemaining:
        return 'User does not have credits remaining. Please contact your DaVinci administrator to add credits.';
      case AgentLockoutReason.CreditsExhaustedAfterCall:
        return 'Credits were exhausted during your last call. You have been logged out. Please contact your DaVinci administrator to add credits.';
      case AgentLockoutReason.InvalidRegionConfiguration:
        return 'The selected profile does not have a valid Agent Configuration Region target. Please contact your DaVinci administrator.';
      case AgentLockoutReason.ConsumptionSubscriptionUnresolved:
        return 'A valid consumption subscription could not be resolved. Please contact your DaVinci administrator.';
      case AgentLockoutReason.NoLicense:
      case AgentLockoutReason.None:
      default:
        return 'User does not have license.Please contact your DaVinci administrator for license.';
    }
  }
}
